import {combineReducers} from 'redux';

import auth from './containers/Auth/Reducer';
import vendor from './containers/Vendor/Reducer';
import main from './containers/Main/Reducer';
import profile from './containers/Profile/Reducer';
import searchResult from './containers/SearchResult/Reducer';
import tour from './containers/TourPage/Reducer';
import cart from './containers/Cart/Reducer';
import userOrders from './containers/UserOrders/Reducer';

export default combineReducers({
  main,
  auth,
  vendor,
  profile,
  searchResult,
  tour,
  cart,
  userOrders,
})


// WEBPACK FOOTER //
// ./src/app/RootReducer.js